




















































































































































import { Component, mixins } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { BasicUserResourceModel } from '@/modules/user/models/user-resource.model'
import { Data, Paginated } from '@/modules/shared/models/data'
import QTable from 'quasar/src/components/table/QTable.js';
import { Wallet } from '@/modules/wallet/services/writer-wallet.service'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'

const { Money } = require('v-money')

@Component({
  components: {
    DateTooltipped,
    Money
  }
})
export default class UsersWalletPage extends mixins(QsSearchableMixin, QsPaginatableMixin) {
  @Prop() writer!: Data<BasicUserResourceModel>
  @Prop() walletLogs!: Paginated<any/*: WalletForm*/>

  protected get model(): Paginated<any> {
    return this.walletLogs
  }

  private walletForm/*: WalletForm*/ = {
    amount: 0,
    description: '',
    type: 'inc',
    note: ''
  }

  getWalletFormAmount() {

    return Number(this.walletForm.amount).toLocaleString()
  }

  updateWallet() {
    Wallet.update(
      this.writer.data.id,
      this.walletForm
    )
  }

  private columns: QTable['columns'] = [
    {
      name: 'index',
      field: 'index',
      label: '#',
      align: 'left'
    },
    {
      name: 'description',
      field: 'description',
      label: 'توضیحات',
      align: 'left',
      style: 'max-width: 200px; white-space: initial'
    },
    {
      name: 'amount',
      field: 'amount',
      label: 'مبلغ (تومان)',
      align: 'left',
      style: 'max-width: 20px'
    },
    {
      name: 'author',
      field: 'author',
      label: 'کاربر',
      align: 'left',
      style: 'max-width: 20px'
    },
    {
      name: 'created_at',
      field: 'created_at',
      label: 'تاریخ',
      align: 'left',
      style: 'max-width: 20px'
    },
    {
      name: 'type',
      field: 'type',
      label: 'نوع',
      align: 'left',
      style: 'max-width: 20px'
    }
  ]

  typeBadgeColor(type: string) {
    switch (type) {
      case 'افزایشی':
        return 'green'
      case 'کاهشی':
        return 'red'
    }
  }
}
